import {
	IResultTrends,
	IResultTrendsRound,
	ISortParams,
} from 'modules/admin-panel/pages/results/models';

export const findCurrentRound = (
	trend: IResultTrends,
	roundId?: string,
): IResultTrendsRound | undefined => {
	if (!trend || !roundId) return;
	return trend?.rounds?.find(({ surveyRoundId }) => surveyRoundId === roundId);
};

export const sortTrends = (
	trendItems: IResultTrends[] | undefined,
	roundId: string | undefined,
	{ type, decreasing = true }: ISortParams,
) => {
	if (!trendItems) return [];

	return [...trendItems].sort((a, b) => {
		const trendA = a[type];
		const trendB = b[type];
		if (trendA === null) return -1;
		if (trendB === null) return 1;
		if (typeof trendA === 'number' && typeof trendB === 'number') {
			return decreasing ? trendB - trendA : trendA - trendB;
		}

		const roundA = findCurrentRound(a, roundId);
		const roundB = findCurrentRound(b, roundId);

		if (!roundA && !roundB) return 0;
		if (!roundA) return -1;
		if (!roundB) return 1;

		const valueA = roundA[type] || 0;
		const valueB = roundB[type] || 0;
		return decreasing ? valueB - valueA : valueA - valueB;
	});
};
